// "use client";

// import React, { useEffect, useRef, useState } from "react";
// import { motion, useAnimation, Variants } from "framer-motion";
// import TaskAltIcon from '@mui/icons-material/TaskAlt';

// function AwardsSection() {
//   const controls = useAnimation();
//   const sectionRef = useRef<HTMLDivElement>(null);
//   const [prevY, setPrevY] = useState(0);

//   useEffect(() => {
//     const observer = new IntersectionObserver(
//       ([entry]) => {
//         const currentY = entry.boundingClientRect.y;

//         if (entry.isIntersecting && currentY > prevY) {
//           controls.start("visible");
//         }
//         setPrevY(currentY);
//       },
//       { threshold: 0.2 }
//     );

//     if (sectionRef.current) {
//       observer.observe(sectionRef.current);
//     }

//     return () => {
//       if (sectionRef.current) {
//         observer.unobserve(sectionRef.current);
//       }
//     };
//   }, [controls, prevY]);

//   const variants = {
//     hiddenLeft: { opacity: 0, x: -100 },
//     hiddenRight: { opacity: 0, x: 100 },
//     visible: {
//       opacity: 1,
//       x: 0,
//       transition: { duration: 1, ease: "easeOut" },
//     },
//   };



//   const childVariants: Variants = {
//     hidden: {
//       opacity: 0,
//       y: 50
//     },
//     visible: {
//       opacity: 1,
//       y: 0,
//       transition: {
//         type: "spring",
//         stiffness: 100,
//         damping: 12
//       }
//     }
//   };

//   return (
//     <div>
//       <div
//         ref={sectionRef}
//         className="bg-[#3A4855] lg:py-5 lg:pb-48 relative  lg:overflow-visible z-20 "
//       >
//       <div className="absolute left-0 right-0 bg-gradient-to-t -top-28 w-full min-h-28 z-20 from-[#3A4855] to-transparent"></div>

//         <h4 className="text-white hidden lg:block text-2xl font-normal pl-28 pt-10">
//           Our Awards
//         </h4>
//         <div className="border-b hidden lg:block border-b-gray-600 mx-28 my-5"></div>

//         <div className="grid grid-cols-6 overflow-hidden">
//           <motion.div
//             initial="hiddenLeft"
//             animate={controls}
//             variants={variants}
//             className="lg:col-span-3 flex justify-center col-span-6 lg:py-10 lg:px-5"
//           >
//             <div className="hidden lg:block">
//               <img
//                 src="/assets/image/awards_bg.png"
//                 alt="Hydraulic excavator arm against blue sky"
//                 className="w-[70vh] h-[80vh] rounded-md object-cover"
//               />
//             </div>

//             <div
//               style={{
//                 backgroundImage: "url('/assets/image/awards_bg.png')",
//                 backgroundSize: "cover",
//                 backgroundPosition: "center",
//               }}
//               className="w-full h-[70vh] block lg:hidden"
//             >
//               <h4 className="text-white text-2xl font-normal pl-8 pt-7">
//                 Our Awards
//               </h4>
//               <div className="border-b border-b-gray-200 my-5 mx-8"></div>
//             </div>
//           </motion.div>

//           <motion.div
//             initial="hiddenRight"
//             animate={controls}
//             variants={variants}
//             className="lg:mt-[110px] lg:col-span-3 font-normal text-sm lg:text-xl col-span-6 lg:pr-40 leading-loose lg:leading-[2rem] p-6 flex flex-col items-start text-white"
//           >
//             <p className="text-lg lg:text-2xl mb-4 font-medium">Our strength ( Value Added Services )</p>

//             <div className="flex flex-col gap-4">
//               <div className="flex items-start gap-4">
//                 <TaskAltIcon   className="mt-1"  sx={{ fontSize: { xs: 22, sm: 24, md: 26, lg: 30 } }}
//  />
//                 <span className="leading-relaxed">
//                   Assembly and testing Facility of Hydraulic Equipments in house.
//                 </span>
//               </div>
//               <div className="flex items-start gap-4">
//                 <TaskAltIcon   className="mt-1"  sx={{ fontSize: { xs: 22, sm: 24, md: 26, lg: 30 } }}
//  />
//                 <span className="leading-relaxed">
//                   We have dismantled and assembled and tested Parker Calzoni Hydraulic Motor of 35000cc at our service center.
//                 </span>
//               </div>
//               <div className="flex items-start gap-4">
//                 <TaskAltIcon   className="mt-1"  sx={{ fontSize: { xs: 22, sm: 24, md: 26, lg: 30 } }}
//  />
//                 <span className="leading-relaxed">
//                   Providing on-site service for piping pickling, flushing, and commissioning of Hydraulic Systems.
//                 </span>
//               </div>
//               <div className="flex items-start gap-4">
//                 <TaskAltIcon   className="mt-1"  sx={{ fontSize: { xs: 22, sm: 24, md: 26, lg: 30 } }}
//  />
//                 <span className="leading-relaxed">
//                   Parker Training Program Conducted at customer Premises and at our service center.
//                 </span>
//               </div>
//             </div>
//           </motion.div>
//         </div>
//       </div>
//       <div ref={sectionRef} className="relative mt-0 sm:mt-0 xs:mt-0 lg:mt-[-125px]">

//         <motion.div
//           initial="hidden"
//           whileInView="visible"
//           viewport={{ once: true, amount: 0.2 }}
//           variants={variants}
//           className="bg-[#AB052D] text-lg lg:min-h-[70vh] text-white lg:relative overflow-hidden grid grid-cols-1 lg:grid-cols-8 lg:ml-[20%] z-20"  // Ensures main2 is above main1
//         >
//           <motion.div
//             variants={childVariants}
//             className="hidden lg:block lg:absolute lg:left-16 lg:top-6 lg:right-20 z-30 p-4 lg:px-10"
//           >
//             <h4 className="text-2xl">Our Success Stories</h4>
//             <div className="border-b w-[60%] border-b-[#C85E6E] my-4"></div>
//           </motion.div>

//           <motion.div
//             variants={variants}
//             className="lg:col-span-3 order-1 lg:order-2 relative"
//           >
//             <motion.div
//               variants={childVariants}
//               style={{
//                 backgroundImage: "url('/assets/image/success_story_bg.png')",
//                 backgroundSize: "cover",
//                 backgroundPosition: "center",
//               }}
//               className="w-full h-[70vh] lg:hidden flex flex-col justify-start p-6 bg-opacity-50 bg-black"
//             >
//               <h4 className="text-white text-2xl font-medium">Our Success Stories</h4>
//               <div className="border-b border-b-gray-200 my-2 w-full"></div>
//             </motion.div>

//             <motion.img
//               variants={childVariants}
//               src="/assets/image/success_story_bg.png"
//               className="hidden w-full h-full lg:block object-cover"
//               alt="Our Success Stories"
//             />
//           </motion.div>

//           <motion.div
//             variants={variants}
//             className="lg:col-span-5 text-sm leading-loose lg:leading-[2rem] lg:text-lg lg:pt-40 lg:p-28 lg:py-32 p-10 order-2 lg:order-1 flex justify-center items-center"
//           >
//             <motion.p
//               variants={childVariants}
//               className="w-full max-w-3xl"
//             >
//               <ul className="list-disc pl-4 mt-0 mb-0 text-lg lg:text-xl inline-block">
//                 <li className="[&::marker]:text-2xl [-webkit-margin-start:0px]">
//                   Hydraulic Test Bench for Apollo Tyres
//                 </li>
//                 <li className="[&::marker]:text-2xl [-webkit-margin-start:0px]">
//                   Hydraulic Cylinder Repairing for Tyre Curing Press of HF Germany
//                 </li>
//                 <li className="[&::marker]:text-2xl [-webkit-margin-start:0px]">
//                   Hydraulic Power pack Commissioning for Anderson USA for Rubber press
//                 </li>
//                 <li className="[&::marker]:text-2xl [-webkit-margin-start:0px]">
//                   And many more to be added..........
//                 </li>
//               </ul>
//             </motion.p>
//           </motion.div>
//         </motion.div>
//       </div>


//     </div>

//   );
// }

// export default AwardsSection;


"use client";

import React from "react";
import { motion, Variants } from "framer-motion";
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import {globalTransition} from "../../../assets/animate/globalAnimation"


function AwardsSection() {
  const containerVariants: Variants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
                ...globalTransition
      },
    },
  };

  const childVariants: Variants = {
    hidden: { opacity: 0, x: -100 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {...globalTransition, ease: "easeOut" },
    },
  };

  const rightChildVariants: Variants = {
    hidden: { opacity: 0, x: 100 },
    visible: {
      opacity: 1,
      x: 0,
      transition: {...globalTransition, ease: "easeOut" },
    },
  };

  const successVariants: Variants = {
    hidden: { opacity: 0, y: 50 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        type: "spring",
        stiffness: 100,
        damping: 12,
      },
    },
  };

  return (
    <div id="awards-section" className="bg-[#3A4855] relative">
              <div className="absolute left-0 right-0 bg-gradient-to-t -top-28 w-full min-h-28 z-20 from-[#3A4855] to-transparent"></div>

      {/* Awards Section */}
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }} // Trigger when 10% is in view
        variants={containerVariants}
        className="bg-[#3A4855] lg:py-5 lg:pb-48 relative lg:overflow-visible z-20"
      >

        <h4 className="text-white hidden lg:block text-2xl font-normal pl-28 pt-10">
          Our Awards
        </h4>
        <div className="border-b hidden lg:block border-b-gray-600 mx-28 my-5"></div>

        <div className="grid grid-cols-6 overflow-hidden">
          <motion.div
            variants={childVariants}
            className="lg:col-span-3 flex justify-center col-span-6 lg:py-10 lg:px-5"
          >
            <div className="hidden lg:block">
              <img
                src="/assets/image/awards_bg.png"
                alt="Hydraulic excavator arm against blue sky"
                className="w-[70vh] h-[80vh] rounded-md object-cover"
              />
            </div>
            <div
              style={{
                backgroundImage: "url('/assets/image/awards_bg.png')",
                backgroundSize: "cover",
                backgroundPosition: "top center", // Move image to avoid cutting off faces
              }}
              // className="w-full h-[70vh] block lg:hidden"
              className="w-full h-[54vh] md:h-[87vh] block lg:hidden"
            >
              <h4 className="text-[#AB052D] text-2xl font-normal pl-8 pt-7">
                Our Awards
              </h4>
              <div className="border-b border-[#AB052D] my-5 mx-8"></div>
            </div>
          </motion.div>

          <motion.div
            variants={rightChildVariants}
            className="lg:mt-[110px] lg:col-span-3 font-normal text-sm lg:text-xl col-span-6 lg:pr-40 leading-loose lg:leading-[2rem] p-6 flex flex-col items-start text-white"
          >
            <p className="text-lg lg:text-2xl mb-4 font-medium">Our strength (Value Added Services)</p>
            <div className="flex flex-col gap-4">
              <div className="flex items-start gap-4">
                <TaskAltIcon className="mt-1" sx={{ fontSize: { xs: 22, sm: 24, md: 26, lg: 30 } }} />
                <span className="leading-relaxed">
                  Assembly and testing Facility of Hydraulic Equipments in house.
                </span>
              </div>
              <div className="flex items-start gap-4">
                <TaskAltIcon className="mt-1" sx={{ fontSize: { xs: 22, sm: 24, md: 26, lg: 30 } }} />
                <span className="leading-relaxed">
                  We have dismantled and assembled and tested Parker Calzoni Hydraulic Motor of 35000cc at our service center.
                </span>
              </div>
              <div className="flex items-start gap-4">
                <TaskAltIcon className="mt-1" sx={{ fontSize: { xs: 22, sm: 24, md: 26, lg: 30 } }} />
                <span className="leading-relaxed">
                  Providing on-site service for piping pickling, flushing, and commissioning of Hydraulic Systems.
                </span>
              </div>
              <div className="flex items-start gap-4">
                <TaskAltIcon className="mt-1" sx={{ fontSize: { xs: 22, sm: 24, md: 26, lg: 30 } }} />
                <span className="leading-relaxed">
                  Parker Training Program Conducted at customer Premises and at our service center.
                </span>
              </div>
            </div>
          </motion.div>
        </div>
      </motion.div>

      {/* Success Stories Section */}
      <div className="relative mt-0 sm:mt-0 xs:mt-0 lg:mt-[-125px]">
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          variants={containerVariants}
          className="bg-[#AB052D] text-lg lg:min-h-[70vh] text-white lg:relative overflow-hidden grid grid-cols-1 lg:grid-cols-8 lg:ml-[20%] z-20"
        >
          <motion.div
            variants={successVariants}
            className="hidden lg:block lg:absolute lg:left-16 lg:top-6 lg:right-20 z-30 p-4 lg:px-10"
          >
            <h4 className="text-2xl">Our Success Stories</h4>
            <div className="border-b w-[60%] border-b-[#C85E6E] my-4"></div>
          </motion.div>

          <motion.div
            variants={successVariants}
            className="lg:col-span-3 order-1 lg:order-2 relative"
          >
            <motion.div
              variants={successVariants}
              style={{
                backgroundImage: "url('/assets/image/success_story_bg.png')",
                backgroundSize: "cover",
                backgroundPosition: "center",
              }}
              className="w-full h-[70vh] lg:hidden flex flex-col justify-start p-6 bg-opacity-50 bg-black"
            >
              <h4 className="text-white text-2xl font-medium">Our Success Stories</h4>
              <div className="border-b border-b-gray-200 my-2 w-full"></div>
            </motion.div>

            <motion.img
              variants={successVariants}
              src="/assets/image/success_story_bg.png"
              className="hidden w-full h-full lg:block object-cover"
              alt="Our Success Stories"
            />
          </motion.div>

          <motion.div
            variants={successVariants}
            className="lg:col-span-5 text-sm leading-loose lg:leading-[2rem] lg:text-lg lg:pt-40 lg:p-28 lg:py-32 p-10 order-2 lg:order-1 flex justify-center items-center"
          >
            <motion.p
              variants={successVariants}
              className="w-full max-w-3xl"
            >
              <ul className="list-disc pl-4 mt-0 mb-0 text-lg lg:text-xl inline-block">
                <li className="[&::marker]:text-2xl [-webkit-margin-start:0px]">
                  Hydraulic Test Bench for Apollo Tyres
                </li>
                <li className="[&::marker]:text-2xl [-webkit-margin-start:0px]">
                  Hydraulic Cylinder Repairing for Tyre Curing Press of HF Germany
                </li>
                <li className="[&::marker]:text-2xl [-webkit-margin-start:0px]">
                  Hydraulic Power pack Commissioning for Anderson USA for Rubber press
                </li>
                <li className="[&::marker]:text-2xl [-webkit-margin-start:0px]">
                  And many more to be added..........
                </li>
              </ul>
            </motion.p>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
}

export default AwardsSection;



